export default __webpack_public_path__ + "bg4acf3fc.png";